package modysy.model

/** Models a game object with a fixed material and geometry.
  *
  * @param body The rigid body of the object. Its material and geometry will not change.
  */
class FixedShapeGameObject(body: RigidBody, initialColor: String)
    extends GameObject(body) {
  private var _color: String = initialColor

  override def color: String = _color

  def color_=(newColor: String): Unit = _color = newColor
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/model/FixedShapeGameObject.scala